export default __webpack_public_path__ + "static/media/Health_Insurance.97890950.svg";